export default {
	'daily-journal': 'Yevmiye özeti',
	'sales-refunds': 'satışlar / iadeler',
	'purchase-refunds': 'Satın alma / iadeler',
	'in-out-cashbox': 'nakit giriş / çıkış',
	total: 'Toplam',
	'cash-total': 'Nakit Toplam',
	'card-total': 'Kart Toplam',
}